import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    return res.data;
  };

  const verifyOtp = async (userId, otp, force = false) => {
    const res = await api.post('/auth/verify-otp', { userId, otp, force });
    if (res.data.conflict) return { conflict: true };
    const { token, user: userData } = res.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const changePassword = async (currentPassword, newPassword) => {
    await api.post('/auth/change-password', { currentPassword, newPassword });
    const updated = { ...user, must_change_password: false };
    localStorage.setItem('user', JSON.stringify(updated));
    setUser(updated);
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const isAdmin      = user?.role === 'admin';
  const isIT         = ['admin', 'it_staff', 'junior_it'].includes(user?.role);
  const isFullIT     = ['admin', 'it_staff'].includes(user?.role); // can edit/manage everything
  const isJuniorIT   = user?.role === 'junior_it';
  const isGeneralUser = user?.role === 'general_user';
  const isDirector   = user?.role === 'director';
  const isFinance    = user?.role === 'finance_staff';
  // View-only roles — can see data but cannot add/edit/delete records
  const isViewOnly   = ['director', 'finance_staff'].includes(user?.role);
  // Roles that have personal General User portal (My Tickets, My Assets, etc.)
  const hasMyPortal  = ['general_user','director','finance_staff','junior_it'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, loading, login, verifyOtp, changePassword, logout, isAdmin, isIT, isFullIT, isJuniorIT, isGeneralUser, isDirector, isFinance, isViewOnly, hasMyPortal }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
